export default __webpack_public_path__ + "static/media/black-man-meditating.9d759e2a.jpg";